export const START_LOADING = "layout/START_LOADING";
export const STOP_LOADING = "layout/STOP_LOADING";
export const RESET_LOADING = "layout/RESET_LOADING";
export const SHOW_ERROR_MODAL = "layout/SHOW_ERROR_MODAL";
export const HIDE_ERROR_MODAL = "layout/HIDE_ERROR_MODAL";

export const startLoading = () => {
  return {
    type: START_LOADING,
  };
};
export const stopLoading = () => {
  return {
    type: STOP_LOADING,
  };
};
export const resetLoading = () => {
  return {
    type: RESET_LOADING,
  };
};
export const showErrorMessage = (data) => {
  return {
    type: SHOW_ERROR_MODAL,
    payload: data,
  };
};
export const hideErrorMessage = () => {
  return {
    type: HIDE_ERROR_MODAL,
  };
};
